import { useLayoutEffect } from 'react';
import { Layout } from '../../components/common/Layout';
import { MedicalCheckupQueueBoard } from '../../components/medical-checkups/MedicalCheckupQueueBoard';

export const MedicalCheckupQueuePage = () => {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = 'white';
    document.body.style.backgroundImage = '';
  });

  return (
    <Layout title="Очередь медосмотров">
      <MedicalCheckupQueueBoard />
    </Layout>
  );
};
